import ReactGA from 'react-ga';

// Initialize tracking id for the project.
export const initGA = (trackingID) => {           
    ReactGA.initialize(trackingID);
 };

// Get url for tracking.
export const raiseGAPageView = () => {
    ReactGA.pageview(window.location.pathname + window.location.search);
};

// Event tracking.
export const raiseGAEvent = (event, label) => {
    ReactGA.event({
      category: event.category,
      action: event.action,
      label: label 
    });
};

export const GA_EVENTS = {
    CLICK_VIEW_MAP: {
        category: 'Click View Map',
        action: 'View store map'
    },
    CLICK_SEARCH_STORE_AVAILABILITY: {
        category: 'Click Search Store Availability',
        action: 'Clicks search store availability button'
    },
    CLICK_VIEW_STORE_DETAILS: {
        category: 'Click View Store Details',
        action: 'Selected store'
    },
    CLOSEST_STORE_WITH_STOCK: {
        category: 'Closest Store With Stock',
        action: 'View closest store'
    },
    CLOSEST_STORE_LOW_STOCK: {
        category: 'Closest Store Low Stock',
        action: 'View closest store'
    },
    CLOSEST_STORE_NO_STOCK: {
        category: 'Closest Store No Stock',
        action: 'View closest store'
    },
    CLICK_EDIT_SELECTION: {
        category: 'Click Edit Selection',
        action: 'Clicks edit selection button'
    },
    VISIT_MY_BAG_PAGE: {
        category: 'My Bag Page',
        action: 'Visit My Bag section'
    },
    VISIT_SHIPPING_PAGE: {
        category: 'Shipping Information',
        action: 'Visit Shipping Information section'
    },
    VISIT_PAYMENT_PAGE: {
        category: 'Payment Details ',
        action: 'Visit Payment Details section'
    },
    VISIT_SUCCESS_PAGE: {
        category: 'Success Page',
        action: 'Visit Order Success Page'
    }
};




